import React from "react";
import {
  Box,
  Typography,
  Paper,
  Container,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import PublicLayout from "../../layouts/PublicLayout";

export default function PrivacyPolicy() {
  return (
    <PublicLayout>
      <Box sx={{ bgcolor: "background.paper", pt: 10, pb: 10 }}>
        <Container maxWidth="md">
          <Typography variant="h3" sx={{ fontWeight: 800, mb: 4 }}>
            Privacy Policy
          </Typography>
          
          <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.8 }}>
            At **ABNScripts Technologies Pvt. Ltd.**, we prioritize your data privacy in compliance with the **Digital Personal Data Protection (DPDP) Act 2023**. This policy outlines how we handle Merchant and Customer data within the TPOS ecosystem.
          </Typography>

          <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>Data Collection Principles</Typography>
          <List sx={{ mb: 4 }}>
            {[
              "Merchant Identity: PAN, GSTIN, and registered business address.",
              "Transaction Metadata: Amount, payment mode, and terminal geolocation.",
              "Customer Data: Phone numbers for digital receipts (collected with consent).",
              "Technical Logs: IP addresses and device health for fraud prevention."
            ].map((text, i) => (
              <ListItem key={i} disableGutters>
                <ListItemIcon sx={{ minWidth: 36 }}><CheckIcon color="primary" /></ListItemIcon>
                <ListItemText primary={text} />
              </ListItem>
            ))}
          </List>

          <Paper sx={{ p: 4, bgcolor: "#f6521a", color: "#fff", borderRadius: 3, mb: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>Data Localization (RBI Compliance)</Typography>
            <Typography variant="body1">
              Strictly following the RBI mandate, all payment-related and personal data are stored exclusively on secure servers located within the **territory of India**.
            </Typography>
          </Paper>

          <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>Your Rights</Typography>
          <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
            Under the DPDP Act, you have the right to access, correct, or request the erasure of your data. For any grievances, please contact our Data Protection Officer at <strong>help@truemenu.in</strong> or visit our office in Pimpri-Chinchwad, Pune.
          </Typography>
        </Container>
      </Box>
    </PublicLayout>
  );
}